import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import styled from 'styled-components';
import { defineMessages, injectIntl } from 'react-intl';
import classNames from 'classnames';
import Content from '../../../internal/Content';
import Entry from '../Entry';
import Chapters from './Chapters';
import CornerMenu from './CornerMenu';
import ProgressBar from './ProgressBar';
import Header from './Header';
var ArticleWrapper = styled.article.withConfig({
  displayName: "Article__ArticleWrapper",
  componentId: "sc-22snot-0"
})(["margin:0 auto;max-width:800px;padding:0 20px;min-height:100vh;position:relative;"]);
var messages = defineMessages({
  chaptersTitle: {
    id: 'hummingbird.Article.chapters.title',
    description: 'Title for list of chapters',
    defaultMessage: 'Chapters'
  },
  skipToContent: {
    id: 'hummingbird.Article.skipToContent.tooltip',
    description: 'Tooltip for landing section link to TOC',
    defaultMessage: 'view the content'
  }
});

var ArticleTemplate =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ArticleTemplate, _Component);

  function ArticleTemplate() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      headers: []
    };

    _this.childProps = function () {
      return {
        headers: _this.state.headers,
        onHeadersChange: function onHeadersChange(headers) {
          return _this.setState({
            headers: headers
          });
        }
      };
    };

    return _this;
  }

  var _proto = ArticleTemplate.prototype;

  _proto.render = function render() {
    return React.createElement(Entry, Object.assign({}, this.props, {
      childProps: this.childProps()
    }));
  };

  return ArticleTemplate;
}(Component);

ArticleTemplate.ProgressBar = ProgressBar;
ArticleTemplate.Header = injectIntl(function (_ref) {
  var _ref$pageContext = _ref.pageContext,
      node = _ref$pageContext.node,
      props = _objectWithoutPropertiesLoose(_ref$pageContext, ["node"]),
      intl = _ref.intl;

  return React.createElement(Header, Object.assign({
    article: node,
    skipToContentTooltip: intl.formatMessage(messages.skipToContent)
  }, props));
});

ArticleTemplate.Navigation = function (_ref2) {
  var _props = _ref2.pageContext;

  var _props$node = _props.node,
      translations = _props$node.translations,
      platforms = _props$node.platforms,
      menu = _props$node.menu,
      locale = _props$node.locale,
      headers = _props.headers,
      shareUrls = _props.shareUrls,
      props = _objectWithoutPropertiesLoose(_props, ["node", "headers", "shareUrls"]);

  return React.createElement(Entry.Navigation, Object.assign({
    chapters: headers,
    shareUrls: shareUrls,
    shareMessage: platforms && platforms.all && platforms.all.description,
    items: menu && menu.items,
    translations: translations,
    locale: locale
  }, props));
};

ArticleTemplate.CornerMenu = injectIntl(function (_ref3) {
  var _ref3$pageContext = _ref3.pageContext,
      _ref3$pageContext$nod = _ref3$pageContext.node,
      translations = _ref3$pageContext$nod.translations,
      locale = _ref3$pageContext$nod.locale,
      headers = _ref3$pageContext.headers,
      intl = _ref3.intl;
  return React.createElement(CornerMenu, {
    chapters: headers,
    locale: locale,
    translations: translations,
    chaptersTitle: intl.formatMessage(messages.chaptersTitle)
  });
});

ArticleTemplate.Main = function (_ref4) {
  var content = _ref4.pageContext.node.content,
      _ref4$headers = _ref4.headers,
      headers = _ref4$headers === void 0 ? [] : _ref4$headers,
      onHeadersChange = _ref4.onHeadersChange,
      _ref4$dropcap = _ref4.dropcap,
      dropcap = _ref4$dropcap === void 0 ? true : _ref4$dropcap;
  return React.createElement("main", null, React.createElement(ArticleWrapper, {
    className: classNames('article')
  }, React.createElement("div", {
    id: "article-start"
  }, headers.length ? React.createElement(Chapters, {
    chapters: headers
  }) : null), React.createElement(Content, {
    className: classNames('mobiledoc-content', {
      'drop-cap': dropcap
    }),
    id: "entry-content",
    content: content,
    onLoad: function onLoad(_ref5) {
      var h = _ref5.headers;
      return onHeadersChange(h);
    }
  })));
};

ArticleTemplate.defaultProps = {
  children: [React.createElement(ArticleTemplate.ProgressBar, null), React.createElement(ArticleTemplate.Navigation, null), React.createElement(ArticleTemplate.CornerMenu, null), React.createElement(ArticleTemplate.Header, null), React.createElement(ArticleTemplate.Main, null)]
};
export { ArticleTemplate as default };